module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAMAAADH72RtAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA5UExURUdwTG5ubm9vb3BwcHBwcG9vb25ubnBwcGpqam1tbW9vb29vb29vb29vb29vb29vb29vb29vb3BwcPUuHCQAAAASdFJOUwB4UrOX6iv7DRtfg0LC0aht2UXx7kIAAAB6SURBVBjTVc/bEoUgCAVQNBTUytr//7EHPF2MF2WNA1vKW6G3DiZakF4KkJV0Q8oXNJFqhy43NUgcFyNx4huMuhP7jKcY6B8YJHkGywDEqbcEwjN5pGJhUD9ggQXHgLIj6f9TguBw4tTrdRU037LrM9FopdJ12hoD/QC5WQT7V6obmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/formImg/close.png
// module id = 4gcd
// module chunks = 0